import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CommonService } from '@shared/common.service';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from '@services/lang.service';
import CONFIG from '@config/app.config';
import URL_CONFIG from '@config/url.config';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { InjuryGroupsInterface } from '@interfaces/injuries.interface';
import { DraftInterface } from '@interfaces/drafts.interface';

@Injectable({
    providedIn: 'root',
})
export class DraftsService {

    public constructor(
        private http: HttpClient,
        private common: CommonService,
        private trans: TranslateService,
        private lang: LangService,
    ) {
    }

    /**
     * Get Drafts
     * @return [description]
     */
    public async getDrafts(
        tournamentId: any,
        year?: any,
        round?: any,
    ): Promise<Observable<DraftInterface>> {
        let iso = this.lang.getLangSnapshot();

        if (iso == null) {
            iso = CONFIG.defaultLang;
        }

        const url = URL_CONFIG.api.getDrafts;

        const params = new HttpParams()
            .set('lang', iso)
            .set('tournamentId', tournamentId ?? '')
            .set('year', year ?? '')
            .set('round', round ?? '')
         ;

        const options = params ? { params } : {};
        return this.http.get<InjuryGroupsInterface>(url, options).pipe(
            catchError(this.common.errorCallback2()), // then handle the error
            tap(this.common.networkOnline()),
        );
    }

}
